import {Header} from "../components/template/header";
import {Sidenav} from "../components/template/sidenav";
import {Outlet} from "react-router-dom";
import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../components/api/webservice";
import {HideMainLoading} from "../components/template/architecture";
import {ShowConnectionFailed} from "../components/template/connection-failed";
import {
    ThinAbsentIcon, ThinAdvertisingIcon,
    ThinBadgeIcon,
    ThinBuildingIcon,
    ThinChart2Icon,
    ThinClassIcon,
    ThinConsentIcon, ThinConsultIcon,
    ThinDashboardIcon,
    ThinExtraPaymentIcon,
    ThinnerPeopleIcon,
    ThinnerSMSIcon,
    ThinSettingIcon,
    ThinStoreIcon,
    ThinTaskIcon
} from "../components/icons/material-icons";
import {Apis} from "../components/api/url";
import {PurchaseToolModal} from "../screens/purchase/purchase-modal";

export const AdminsDashboardArch = () => {
    const [data, setData] = useState({
        loading: true,
        firstName: '',
        lastName: '',
        role: '',
        tickets: 0,
    });
    const [access, setAccess] = useState({
        students: false,
        finance: false,
        classes: false,
        attend: false,
        point: false,
        sci: false,
        extra: false,
        news: false,
        consents: false,
        tickets: false,
        users: false,
        staff: false,
        settings: false,
        presignup: false,
    });
    useEffect(() => {
        PostJSON(
            Apis.server + "/core/admins/account/info",
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                firstName: string,
                lastName: string,
                role: string,
                ticketsCount: number,
                studentsList: 0 | 1,
                finance: 0 | 1,
                classes: 0 | 1,
                attend: 0 | 1,
                point: 0 | 1,
                sciCenter: 0 | 1,
                extraPayments: 0 | 1,
                news: 0 | 1,
                consents: 0 | 1,
                tickets: 0 | 1,
                users: 0 | 1,
                staff: 0 | 1,
                settings: 0 | 1,
                presignup: 0 | 1,
            }) => {
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                HideMainLoading();
                setData({
                    loading: false,
                    firstName: d.firstName,
                    role: d.role,
                    lastName: d.lastName,
                    tickets: d.ticketsCount,
                });
                setAccess({
                    tickets: d.tickets === 1,
                    attend: d.attend === 1,
                    finance: d.finance === 1,
                    classes: d.classes === 1,
                    extra: d.extraPayments === 1,
                    consents: d.consents === 1,
                    sci: d.sciCenter === 1,
                    news: d.news === 1,
                    point: d.point === 1,
                    staff: d.staff === 1,
                    students: d.studentsList === 1,
                    users: d.users === 1,
                    settings: d.settings === 1,
                    presignup: d.presignup === 1,
                });
            },
            () => {
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    }, []);
    const hr = {
        icon: null,
        name: null,
        to: null,
        count: null,
        hide: false,
        unavailableClick: void (0),
        available: true,
    };
    const nothing = {
        icon: null,
        name: null,
        to: null,
        count: null,
        hide: true,
        unavailableClick: void (0),
        available: true,
    };
    const [purchaseModal, setPurchaseModal] = useState({
        show: false,
        title: '',
        options: [] as string[],
    });
    return (
        <>
            {
                data.loading ? null :
                    <>
                        <Header
                            panel={"admin"}
                            name={data.firstName + " " + data.lastName}
                            role={data.role}
                            headerTitle={"مدرسه نهال - پنل اداری"}
                        />
                        <Sidenav
                            panel={"admins"}
                            items={[
                                {
                                    name: "داشبورد",
                                    icon: <ThinDashboardIcon/>,
                                    to: "/admins/overview",
                                    count: 0,
                                    hide: false,
                                    unavailableClick: void (0),
                                    available: true,
                                },
                                {
                                    name: "دانش‌آموزان",
                                    icon: <ThinnerPeopleIcon/>,
                                    to: "/admins/students",
                                    count: 0,
                                    hide: !access.students,
                                    unavailableClick: void (0),
                                    available: true,
                                },
                                {
                                    name: "امور مالی",
                                    icon: <ThinChart2Icon/>,
                                    to: "/admins/finance",
                                    count: 0,
                                    hide: !access.finance,
                                    unavailableClick: void (0),
                                    available: true,
                                },
                                {
                                    name: "کلاس‌ها",
                                    icon: <ThinClassIcon/>,
                                    to: "/admins/classes",
                                    count: 0,
                                    hide: !access.classes,
                                    unavailableClick: void (0),
                                    available: true,
                                },
                                hr,
                                {
                                    name: "حضوروغیاب",
                                    icon: <ThinAbsentIcon/>,
                                    to: "/admins/attend",
                                    count: 0,
                                    hide: !access.attend,
                                    unavailableClick: void (0),
                                    available: true,
                                },
                                {
                                    name: "بوفه",
                                    icon: <ThinStoreIcon/>,
                                    to: "/admins/store",
                                    count: 0,
                                    hide: !access.point,
                                    unavailableClick:void(0),
                                    // unavailableClick: () => setPurchaseModal({
                                    //     show: true,
                                    //     title: "بوفه هوشمند",
                                    //     options: [
                                    //         'امکان خرید از بوفه مدرسه با کارت هوشمند دانش‌آموزی',
                                    //         'امکان دریافت شارژ بوفه با پرداخت آنلاین',
                                    //         'حسابداری کامل برای بخش بوفه',
                                    //         'لیست افراد دارای موجودی بوفه',
                                    //         'لیست خریدهای انجام شده از بوفه',
                                    //         'لیست پرداخت های آنلاین',
                                    //         'امکان تنظیم رمز عددی ۴ رقمی توسط والدین روی کارت',
                                    //         'امکان تعیین سقف برداشت برای هر دانش‌آموز توسط مدیر و والدین',
                                    //     ],
                                    // }),
                                    available: true,
                                },
                                access.point || access.attend ? hr : nothing,
                                // {
                                //     name: "کلاس فوق برنامه",
                                //     icon: <ThinBuildingIcon/>,
                                //     to: "/admins/center",
                                //     count: 0,
                                //     hide: !access.sci,
                                //     unavailableClick: () => setPurchaseModal({
                                //         show: true,
                                //         title: "کلاس‌های فوق برنامه",
                                //         options: [
                                //             'امکان تعریف کلاس‌های فوق برنامه',
                                //             'امکان دریافت هزینه کلاس بصورت پرداخت آنلاین',
                                //             'مشاهده لیست کلاس‌های من برای دانش‌آموزان',
                                //             'قابلیت پیش ثبت نام و تایید نهایی ثبت‌نام در صورت رسیدن به حد نساب',
                                //             'امکان اطلاع رسانی پیامکی برای کلاس جدید، تایید ثبت‌نام و عدم برگزاری کلاس',
                                //             'امکان تعیین دانش‌آموزان متمایز (تیزهوشان) برای هر کلاس',
                                //             'لیست پرداختی های هر کلاس و دانش‌آموزان بدهکار',
                                //         ],
                                //     }),
                                //     available: false,
                                // },
                                {
                                    name: "کارمندان",
                                    icon: <ThinBadgeIcon/>,
                                    to: "/admins/staff",
                                    count: 0,
                                    hide: !access.staff,
                                    unavailableClick: () => setPurchaseModal({
                                        show: true,
                                        title: "کارمندان",
                                        options: [
                                            'لیست کارمندان مدرسه شامل کادر اداری، دبیران و...',
                                            'پنل مجزا مخصوص دبیران و کارمندان',
                                            'تکمیل اطلاعات پرسنل در پنل مخصوص',
                                            'تعریف حقوق، بیمه و پاداش و همراه با خروجی مستقیم برای ارسال به بانک',
                                            'امکان حضورغیاب همکاران از طریق کارت های هوشمند (با همان دستگاه حضورغیاب دانش‌آموزی)',
                                            'امکان اطلاع رسانی رسانی پیامکی به کارمندان',
                                            'امکان ثبت درخواست توسط کارمندان و پاسخگویی توسط مدیر',
                                        ],
                                    }),
                                    available: true,
                                },
                                // {
                                //     name: 'پرداخت متفرقه',
                                //     icon: <ThinExtraPaymentIcon/>,
                                //     to: '/admins/extra',
                                //     count: 0,
                                //     hide: !access.extra,
                                //     unavailableClick: () => setPurchaseModal({
                                //         show: true,
                                //         title: "پرداخت‌های متفرقه",
                                //         options: [
                                //             'امکان دریافت وجه از طریق پرداخت آنلاین از والدین',
                                //             'ثبت مواردی مثل بیمه دانش‌آموزی، هزینه کارت هوشمند، هزینه اردو و...',
                                //             'خروجی پرینت، pdf و اکسل پرداخت های موفق',
                                //         ],
                                //     }),
                                //     available: false,
                                // },
                                {
                                    name: "اطلاعیه‌ها",
                                    icon: <ThinAdvertisingIcon/>,
                                    to: "/admins/news",
                                    count: 0,
                                    hide: !access.news,
                                    unavailableClick: () => setPurchaseModal({
                                        show: true,
                                        title: "اطلاعیه ها",
                                        options: [
                                            'امکان ثبت اطلاعیه برای نمایش در پنل دانش‌آموزی و سایت',
                                            'امکان اطلاع‌رسانی پیامکی برای هر اطلاعیه به دانش‌آموزان هدف',
                                            'امکان ثبت نام دانش‌آموز در اطلاعیه (مثلا برای انتخابات شورای دانش‌آموزی)',
                                            'خروجی اکسل و پرینت دانش‌آموزان ثبت‌نام شده',
                                        ],
                                    }),
                                    available: true,
                                },
                                {
                                    name: "رضایت‌نامه ها",
                                    icon: <ThinConsentIcon/>,
                                    to: "/admins/consents",
                                    count: 0,
                                    hide: !access.consents,
                                    unavailableClick: () => setPurchaseModal({
                                        show: true,
                                        title: "رضایت‌نامه آنلاین",
                                        options: [
                                            'امکان تعریف و ثبت رضایت‌نامه برای دانش‌آموزان بصورت همگانی، کلاسی و موارد خاص',
                                            'امکان اعتبارسنجی امضای رضایت نامه با ارسال کد تایید ۵ رقمی به والدین در پنل دانش‌آموزی',
                                            'امکان چاپ رضایت‌نامه کاغذی برای دانش‌آموزانی که امضا کرده‌اند',
                                            'امکان اطلاع‌رسانی پیامکی به والدین هنگام ثبت رضایت‌نامه جدید',
                                        ],
                                    }),
                                    available: true,
                                },
                                {
                                    name: "مشاوره",
                                    icon: <ThinConsultIcon/>,
                                    to: "/admins/consult",
                                    count: 0,
                                    hide: false,
                                    available: true,
                                    unavailableClick: () => {
                                    },
                                },
                                access.sci || access.extra || access.news || access.consents ? hr : nothing,
                                {
                                    name: "پیش ثبت‌نام",
                                    icon: <ThinTaskIcon/>,
                                    to: "/admins/presignup",
                                    count: 0,
                                    hide: !access.presignup,
                                    available: true,
                                    unavailableClick: () => {
                                    },
                                },
                                {
                                    name: "تیکت",
                                    icon: <ThinnerSMSIcon/>,
                                    to: "/admins/tickets",
                                    count: data.tickets,
                                    hide: !access.tickets,
                                    unavailableClick: void (0),
                                    available: true,
                                },
                                {
                                    name: 'تنظیمات',
                                    icon: <ThinSettingIcon/>,
                                    to: '/admins/settings',
                                    count: 0,
                                    hide: !access.settings,
                                    unavailableClick: void (0),
                                    available: true,
                                },
                            ]}
                        />
                        <main id="main" className="large-nav">
                            <Outlet/>
                        </main>
                    </>
            }
            <PurchaseToolModal
                active={purchaseModal.show}
                closeHandler={() => setPurchaseModal({
                    show: false,
                    options: [],
                    title: '',
                })}
                title={purchaseModal.title}
                options={purchaseModal.options}
            />
        </>
    );
};